import api from "../security/api";

const viewDocsFindAll = (client, instance) => {
    return api
        .get(`docs/findAll?client=${client}&instance=${instance}`);
};

const docService = {
    viewDocsFindAll
};


export default docService;
